export default __webpack_public_path__ + "static/referral-cc9c32491e06d7014cde9e45de5257c8.png";